import React from 'react';

const Card = ({ children, variant = 'elevation', elevation = 1, className = '', ...props }) => {
  const baseClasses = 'bg-white rounded-lg';

  const variants = {
    elevation: 'shadow-md',
    outlined: 'border border-gray-200',
    flat: 'shadow-none',
  };

  const elevations = {
    0: 'shadow-none',
    1: 'shadow-sm',
    2: 'shadow-md',
    3: 'shadow-lg',
    4: 'shadow-xl',
    5: 'shadow-2xl',
  };

  const classes = `${baseClasses} ${variants[variant]} ${elevations[elevation]} ${className}`;

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

const CardContent = ({ children, className = '', ...props }) => {
  return (
    <div className={`p-6 ${className}`} {...props}>
      {children}
    </div>
  );
};

const CardActions = ({ children, className = '', ...props }) => {
  return (
    <div className={`px-6 py-3 flex items-center justify-end space-x-2 ${className}`} {...props}>
      {children}
    </div>
  );
};

const CardHeader = ({ title, subtitle, action, avatar, className = '', ...props }) => {
  return (
    <div className={`px-6 py-4 flex items-center ${className}`} {...props}>
      {avatar && <div className='mr-4'>{avatar}</div>}
      <div className='flex-1'>
        {title && <h3 className='text-lg font-semibold text-gray-900'>{title}</h3>}
        {subtitle && <p className='text-sm text-gray-600 mt-1'>{subtitle}</p>}
      </div>
      {action && <div className='ml-4'>{action}</div>}
    </div>
  );
};

Card.Content = CardContent;
Card.Actions = CardActions;
Card.Header = CardHeader;

export default Card;
